
export const url = "https://api.bawabatek.com/admin";
export const BASE_URL = "https://admin.bawabatek.com/";
export const API_KEY = "al-mahara-2023-development-api-key";
export const GOOGLE_MAP_KEY = `AIzaSyD-N8juGZkx72ZlDVByhmb9Dz_ke62d-sQ`;
